<template>
  <img loading="lazy" :src="gravatarUrl" alt="user avatar" />
</template>

<script setup lang="ts">
import { Md5 } from "ts-md5";
import { computed } from "vue";
import { useClientStore } from "../store/client";

const client = useClientStore();

const gravatarHash = computed(() => (client.me ? Md5.hashStr(client.me.jwt.email) : "default"));
const gravatarUrl = computed(() => `https://www.gravatar.com/avatar/${gravatarHash.value}`);
</script>
